import React, { useContext, useEffect } from 'react';
import {
  Outlet, useLocation, useNavigate
} from 'react-router-dom';

import { NewHDContext } from './new-hd-composer';

export function NewHDGuard({ initLoad, setInitLoad }) {
  const navigate = useNavigate();
  const location = useLocation();
    
  const { healthcareDirective } = useContext(NewHDContext);
  
  console.log('INIT LOAD', initLoad);
  
  useEffect(() => {
    console.log('NewHAGuard effect', healthcareDirective, location);
    setInitLoad(false);
  
    if (healthcareDirective && healthcareDirective.status === 'complete') {
      console.log('existing completed healthcare directive', healthcareDirective);
      return navigate({
        pathname: `/people/self/life-documents/healthcare-directive/${healthcareDirective.id}`,
        search: location.search
      }, { replace: true });
    }
  
    if (healthcareDirective && initLoad) {
      console.log('existing healthcare directive', healthcareDirective);
      return navigate({
        pathname: '/people/self/life-documents/healthcare-directive/new/continue',
        search: location.search
      }, { replace: true });
    }
  
    if (healthcareDirective) {
      console.log('existing draft healthcare directive', healthcareDirective);
      return;
    }
  
    return navigate({
      pathname: '/people/self/life-documents/healthcare-directive/new',
      search: location.search
    }, { replace: true });
  }, [ initLoad, location.search, navigate, setInitLoad, healthcareDirective, location ]);
  
  return <Outlet />; // Render the nested routes
}